const CheckpointCompleted = () => (
  <span className="text-[9px] py-[2px] md:text-xs bg-teal-100 text-teal-700 px-2 md:py-1 rounded-full">
    Completed
  </span>
);

export default CheckpointCompleted;
